const DEFAULT_SORT_PARAM = null;

export default {
  state: {
    defaultSortParam: DEFAULT_SORT_PARAM,
    currentSortParam: DEFAULT_SORT_PARAM,
    sortParams: [
      'date_asc',
      'date_desc',
      'file_name_asc',
      'file_name_desc',
    ],
  },
  getters: {
    SORT_PARAMS: state => {
      return state.sortParams;
    },
    CURRENT_SORT_PARAM: state => {
      return state.currentSortParam;
    },
    DEFAULT_SORT_PARAM: state => {
      return state.defaultSortParam;
    },
  },
  mutations: {
    SET_CURRENT_SORT_PARAM: (state, payload) => {
      state.currentSortParam = payload;
    },
  },
  actions: {
    SET_CURRENT_SORT_PARAM: (context, currentSortParam) => {
      context.commit('SET_CURRENT_SORT_PARAM', currentSortParam);
    },
  },
};